import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';
import { save, load } from "redux-localstorage-simple"

const createStoreWithMiddleware = compose(applyMiddleware(thunk, save()))(createStore)
let store = createStoreWithMiddleware(reducer,load())
export { store }



// WEBPACK FOOTER //
// ./src/store.js